import React from "react";
import common_images from '../common-images';

class InnogyStyleIcon extends React.Component {

    render() {

        const { alt, width, height, className } = this.props;
        let childProps = {
            alt, width, height, className
        };

        switch (this.props.style) {
            case "digitalization": return (<img src={common_images.innogy_style.is_digitalization} {...childProps} />);
            case "values": return (<img src={common_images.innogy_style.is_values} {...childProps}/>);
            case "people": return (<img src={common_images.innogy_style.is_people} {...childProps}/>);
            case "personal_growth": return (<img src={common_images.innogy_style.is_personal_growth} {...childProps}/>);
            case "work_environment": return (<img src={common_images.innogy_style.is_work_environment} {...childProps}/>);
            case "work_style": return (<img src={common_images.innogy_style.is_work_style} {...childProps}/>);
            default: return null;
        }
    }

}

export default InnogyStyleIcon;
